// Copyright Epic Games, Inc. All Rights Reserved.

import { Button } from "@material-ui/core";
import { LoadingSpinner } from "./LoadingSpinner";
import React from "react";
import {
  useCancelInstallationDispatchAction,
  useCancellingInstallationFlag,
} from "../../store/installation/hooks";
import { useLocMessage } from "../../store/localization/hooks";

export const CancelButton = (): JSX.Element => {
  const cancelling = useCancellingInstallationFlag();
  const cancelInstallation = useCancelInstallationDispatchAction();
  const cancelButtonText = useLocMessage("cancelation.button", "Cancel");

  if (cancelling) {
    return <LoadingSpinner size={15} />;
  }

  return (
    <Button
      color="primary"
      size="small"
      variant="text"
      disabled={cancelling}
      onClick={cancelInstallation}
    >
      {cancelButtonText}
    </Button>
  );
};
